/* cart-drawer.js — Blue Dahlia
   FIX: Race condition on add-to-cart resolved.
   
   Root cause: drawer was opening then calling render() which fetched /cart.js
   — but Shopify hadn't finished saving the new item yet, so the first render
   showed the old cart. A second fetch after the delay showed the correct cart.

   Fix: The fetch interceptor now reads the /cart/add RESPONSE directly.
   Shopify's /cart/add.js response contains the added item. We then call
   /cart.js once immediately after — at this point Shopify has definitely
   saved it because /cart/add.js already returned successfully.
   The drawer opens with correct products on the very first render.
*/
(function () {
  'use strict';

  var overlay  = document.getElementById('bd-cart-overlay');
  var drawer   = document.getElementById('bd-cart-drawer');
  var body     = document.getElementById('bd-body');
  var footer   = document.getElementById('bd-ft');
  var subtotal = document.getElementById('bd-subtotal');
  var closeBtn = document.getElementById('bd-close-btn');

  if (!overlay || !drawer) return;

  function fmt(cents) {
    try {
      if (window.Currency && Currency.formatMoney) return Currency.formatMoney(cents, theme.settings.moneyFormat);
      if (window.Shopify  && Shopify.formatMoney)  return Shopify.formatMoney(cents, theme.settings.moneyFormat);
    } catch(e) {}
    return '\u20B9\u00A0' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function esc(s) {
    if (!s) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function open() {
    overlay.classList.add('bd-open');
    drawer.classList.add('bd-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ drawer.focus(); }, 50);
  }

  function close() {
    overlay.classList.remove('bd-open');
    drawer.classList.remove('bd-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* render() — used for manual opens (cart icon click, cart-drawer:open event)
     NOT called after add-to-cart. Those go through openWithFreshCart() instead. */
  function render() {
    if (body.querySelectorAll('.bd-item').length > 0) {
      body.style.opacity = '0.5';
      body.style.pointerEvents = 'none';
    } else {
      body.innerHTML = '<div class="bd-state">Loading\u2026</div>';
      footer.classList.remove('bd-ft-visible');
    }
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        body.style.opacity = '1';
        body.style.pointerEvents = 'auto';
        buildUI(cart);
      })
      .catch(function(){
        body.style.opacity = '1';
        body.style.pointerEvents = 'auto';
        body.innerHTML = '<div class="bd-state">Could not load cart.<br><a href="/cart">View cart \u2192</a></div>';
      });
  }

  /* openWithFreshCart() — called AFTER /cart/add.js has already responded.
     At this point Shopify has confirmed the item is saved, so /cart.js
     is guaranteed to return the updated cart on the very first fetch. */
  function openWithFreshCart() {
    if (isCartPage) return;

    /* Show drawer immediately with loading state — no flicker of old items */
    body.innerHTML = '<div class="bd-state">Loading\u2026</div>';
    footer.classList.remove('bd-ft-visible');
    open();

    /* Fetch fresh cart — Shopify has already saved the item by this point */
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ buildUI(cart); })
      .catch(function(){
        body.innerHTML = '<div class="bd-state">Could not load cart.<br><a href="/cart">View cart \u2192</a></div>';
      });
  }

  function buildUI(cart) {
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="bd-state">Your cart is empty.</div>';
      footer.classList.remove('bd-ft-visible');
      syncBadge(0);
      return;
    }
    var html = '';
    cart.items.forEach(function(item) {
      var imgHtml = item.image
        ? '<img class="bd-item-img" src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
        : '<div class="bd-item-img-ph"></div>';
      var propsHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var parts = item.variant_title.split(' / ');
        if (parts.length >= 2) {
          propsHtml  = '<p class="bd-item-prop"><strong>Size:</strong> '  + esc(parts[0]) + '</p>';
          propsHtml += '<p class="bd-item-prop"><strong>Color:</strong> ' + esc(parts[1]) + '</p>';
        } else {
          propsHtml = '<p class="bd-item-prop">' + esc(item.variant_title) + '</p>';
        }
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function(k) {
          if (item.properties[k] && k.charAt(0) !== '_') {
            propsHtml += '<p class="bd-item-prop"><strong>' + esc(k) + ':</strong> ' + esc(String(item.properties[k])) + '</p>';
          }
        });
      }
      html += [
        '<div class="bd-item" data-key="' + esc(item.key) + '">',
          imgHtml,
          '<div class="bd-item-info">',
            '<p class="bd-item-name">' + esc(item.product_title) + '</p>',
            propsHtml,
            '<div class="bd-qty-row">',
              '<div class="bd-qty-wrap">',
                '<button class="bd-qty-btn bd-dec" data-key="' + esc(item.key) + '" aria-label="Decrease">\u2212</button>',
                '<span class="bd-qty-val">' + item.quantity + '</span>',
                '<button class="bd-qty-btn bd-inc" data-key="' + esc(item.key) + '" aria-label="Increase">+</button>',
              '</div>',
              '<button class="bd-del" data-key="' + esc(item.key) + '" aria-label="Remove">',
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
                  '<polyline points="3 6 5 6 21 6"/>',
                  '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>',
                  '<path d="M10 11v6M14 11v6"/>',
                  '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>',
                '</svg>',
              '</button>',
              '<span class="bd-item-price">' + fmt(item.line_price) + '</span>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    });
    body.innerHTML = html;
    body.querySelectorAll('.bd-dec').forEach(function(btn) {
      btn.addEventListener('click', function(){ changeQty(btn.dataset.key, -1); });
    });
    body.querySelectorAll('.bd-inc').forEach(function(btn) {
      btn.addEventListener('click', function(){ changeQty(btn.dataset.key, +1); });
    });
    body.querySelectorAll('.bd-del').forEach(function(btn) {
      btn.addEventListener('click', function(){ removeItem(btn.dataset.key); });
    });
    subtotal.textContent = fmt(cart.total_price);
    footer.classList.add('bd-ft-visible');
    syncBadge(cart.item_count);
  }

  function changeQty(key, delta) {
    var itemEl = body.querySelector('[data-key="' + key + '"]');
    var qtyEl  = itemEl && itemEl.querySelector('.bd-qty-val');
    if (!qtyEl) return;
    var newQty = (parseInt(qtyEl.textContent, 10) || 0) + delta;
    if (newQty <= 0) { removeItem(key); return; }
    if (itemEl) itemEl.classList.add('bd-busy');
    cartChange(key, newQty);
  }

  function removeItem(key) {
    var itemEl = body.querySelector('[data-key="' + key + '"]');
    if (itemEl) itemEl.classList.add('bd-busy');
    cartChange(key, 0);
  }

  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){ buildUI(cart); })
    .catch(function(){ render(); });
  }

  function syncBadge(count) {
    count = parseInt(count, 10) || 0;
    var selectors = [
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-link__bubble-num',
      '.site-nav__cart-count',
      '.cart-link__bubble',
      '.cart-link__count',
      '[data-cart-count]',
      '.site-header__cart-count',
      '.cart__count',
      '#CartCount',
      '.cart-count',
      '.js-cart-count',
      '[data-header-cart-count]',
      '.header__cart-count',
      '[data-cart-count-bubble]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
        el.style.display = '';
        el.classList.remove('hide', 'hidden', 'is-hidden', 'd-none');
        var dawnBubble = el.closest('.cart-count-bubble');
        if (dawnBubble) dawnBubble.classList.remove('hidden', 'is-hidden');
        var archBubble = el.closest('.cart-link__bubble');
        if (archBubble) archBubble.classList.remove('is-hidden');
      } else {
        el.setAttribute('hidden', '');
        el.classList.add('hide', 'hidden', 'is-hidden');
        var dawnBubble = el.closest('.cart-count-bubble');
        if (dawnBubble) dawnBubble.classList.add('hidden');
        var archBubble = el.closest('.cart-link__bubble');
        if (archBubble) archBubble.classList.add('is-hidden');
      }
    });
    document.querySelectorAll('[class*="ai-header-cart-count-"]').forEach(function(el) {
      el.textContent   = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count, fromDrawer: true }, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* ── Open/close listeners ── */
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('bd-open')) close();
  });

  var isCartPage = window.location.pathname.indexOf('/cart') !== -1;

  /* Cart icon click — opens drawer and fetches current cart */
  document.addEventListener('click', function(e) {
    if (isCartPage) return;
    if (e.target.closest('button[name="checkout"]')) return;
    if (e.target.closest('form[action="/cart"]')) return;
    if (e.target.closest('#bd-cart-drawer')) return;
    var link = e.target.closest('a[href="/cart"]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    open();
    render();
  }, true);

  document.addEventListener('cart-drawer:open',    function(){ if (!isCartPage){ open(); render(); } });
  document.addEventListener('cart-drawer:close',   function(){ close(); });
  document.addEventListener('cart-drawer:refresh', function(){ render(); });

  window.CartDrawer = { open: function(){ if (!isCartPage){ open(); render(); } }, close: close, render: render, syncBadge: syncBadge };

  /* ── Add-to-cart interception ──
     KEY FIX: We intercept the /cart/add response and call openWithFreshCart()
     AFTER the response is received — not before. At that exact moment Shopify
     has confirmed the item is saved, so the very next /cart.js fetch returns
     the correct updated cart with no race condition and no double-render.
  ── */

  /* 1. Intercept fetch() */
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function() {
      var args = arguments;
      var reqUrl = args[0];
      if (reqUrl && typeof reqUrl === 'object') reqUrl = reqUrl.url;
      var isAdd = reqUrl && typeof reqUrl === 'string' && reqUrl.indexOf('/cart/add') !== -1;

      if (!isAdd) return originalFetch.apply(this, args);

      /* Clone the response so the theme can still read it */
      return originalFetch.apply(this, args).then(function(res) {
        if (res.ok) {
          /* Item confirmed saved by Shopify — open drawer now */
          openWithFreshCart();
        }
        return res;
      });
    };
  }

  /* 2. Intercept XHR (jQuery $.ajax add-to-cart) */
  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._isAddToCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    if (this._isAddToCart) {
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) openWithFreshCart();
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

})();
